import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { updateDialog } from 'store/dialog/reducer';
import CustomButton from 'components/CustomInput/Button';
import styled from 'styled-components';
import ErrorIcon from '@material-ui/icons/Error';

const SContent = styled.div`
    min-width: 400px;
    font-weight: 500;
    display: flex;
`;

const ConfirmDialog = ({ type = '' }) => {
    const isShow = useSelector((state) => state.dialog.confirmDialog.isShow);
    const title = useSelector((state) => state.dialog.confirmDialog.title);
    const description = useSelector((state) => state.dialog.confirmDialog.description);
    const confirmText = useSelector((state) => state.dialog.confirmDialog.confirmButtonText);
    const cancelText = useSelector((state) => state.dialog.confirmDialog.cancelButtonText);
    const disableCancelButton = useSelector((state) => state.dialog.confirmDialog.disableCancelButton);
    const isError = useSelector((state) => state.dialog.confirmDialog.isError);
    const messages = useSelector((state) => state.dialog.confirmDialog.messages);
    const extraTips = useSelector((state) => state.dialog.confirmDialog.extraTips);
    const callback = useSelector((state) => state.dialog.confirmDialog.callback);
    const dispatch = useDispatch();

    const handleOk = () => {
        if (callback) {
            callback();
        }
        dispatch(
            updateDialog({
                result: true,
                // isShow: true,
            }),
        );
    };

    const handleCancel = () => {
        dispatch(
            updateDialog({
                result: false,
                // isShow: true,
            }),
        );
    };

    return (
        <Dialog open={isShow} style={{ margin: 'auto' }}>
            {title && (
                <DialogTitle style={{ fontWeight: 'bold', width: 400 }}>
                    <div style={{ fontSize: 16 }}>{title}</div>
                </DialogTitle>
            )}

            <DialogContent style={{ width: 400 }}>
                {description && (
                    <SContent>
                        {isError && (
                            <div style={{ paddingRight: 5 }}>
                                <ErrorIcon style={{ color: '#CD5C5C' }} />
                            </div>
                        )}
                        <DialogContentText style={{ paddingTop: 2, fontWeight: !title ? 'bold' : 'normal' }}>
                            {description}
                        </DialogContentText>
                    </SContent>
                )}
                {messages?.map((item, index) => {
                    return <div key={index}>{item}</div>;
                })}
                {extraTips && <div style={{ marginTop: 20, fontSize: 13, color: 'red' }}>{extraTips}</div>}
            </DialogContent>
            <DialogActions style={{ padding: 15 }}>
                {!disableCancelButton && (
                    <CustomButton type={'cancel'} onClick={handleCancel}>
                        {cancelText ?? 'Cancel'}
                    </CustomButton>
                )}

                <CustomButton onClick={handleOk} autoFocus>
                    {confirmText ?? 'Confirm'}
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
